// mainItemTypes  : Main Section|  Section | MenuItem | Parent
// linkType       : Internal | External | null

import {
  ABOUT_CAREERS,
  ABOUT_INVESTOR_RELATIONS,
  ABOUT_NEWS_ROOM,
  ABOUT_PATH,
  ABOUT_WHO_WE_ARE,
  ACQUIRED_ASSETS_AUTO_LOANS,
  ACQUIRED_ASSETS_PROPERTY,
  ADVISORIES,
  BUSINESS,
  BUSINESS_CASH_MANAGEMENT,
  BUSINESS_CASH_MANAGEMENT_SOLUTION,
  BUSINESS_DEPOSIT,
  BUSINESS_FOREX_SERVICE,
  BUSINESS_INSURANCE,
  BUSINESS_INVESTMENT,
  BUSINESS_LOAN_SOLUTION,
  CARDS_CREDIT_CARDS,
  CARDS_DEBIT_CARDS,
  CARDS_PREPAID_CARDS,
  CONTACT_US,
  DEPOSITS_CHECKING_PAGE,
  DEPOSITS_FOREIGN_CURRENCY_DEPOSIT,
  DEPOSITS_LANDING_PAGE,
  DEPOSITS_SAVING_PAGE,
  DEPOSITS_TIERED_PAGE,
  DEPOSITS_TIME_DEPOSIT,
  EASYWAY_STAND_ALONE_PATH,
  INSTAPAY_PESONET,
  INVESTMENTS_FIXED_INCOME,
  INVESTMENTS_OVERVIEW,
  INVESTMENTS_TRUST,
  INVESTMNETS_UITF,
  LOANS_AUTO_LOANS,
  LOANS_HOME_LOANS,
  LOANS_OVERVIEW,
  LOANS_PERSONAL_LOANS,
  PRIVACY_STATEMENT,
  STORE_DIRECTORY,
  TERMS_OF_USE_PATH,
  OTHER_SERVICES_EWBILLERS,
} from "routes/paths";
import {
  AGEAS_INSURANCE,
  EASTWEST_CORPORATE,
  EASTWEST_ONLINE_PAGE,
  EASYWAY_PERSONAL_ONLINE,
  EASYBIZ_CORPORATE_ONLINE,
  INSURANCE_BROKERAGE,
  OLD_EASYWAY,
  PRIORITY_WEBSITE,
  TRAVEL_MONEY_URL,
} from "utils/urls";

export const MAIN_ITEM_MAIN_SECTION = "Main Section";
export const MAIN_ITEM_SECTION = "Section"; //Static/ Not Collapsible
export const MAIN_ITEM_MENU_ITEM = "MenuItem"; //Single Item/Not Collapsible
export const MAIN_ITEM_PARENT = "Parent"; //Collapsible
export const LINK_TYPE_EXTERNAL = "Link Type External"; //external urls
export const LINK_TYPE_INTERNAL = "Link Type Internal";

const DEPOSIT_SUBITEMS = [
  {
    title: "Deposits Overview",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: DEPOSITS_LANDING_PAGE,
    subItems: [],
  },
  {
    title: "Savings",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: DEPOSITS_SAVING_PAGE,
    subItems: [],
  },
  {
    title: "Checking",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: DEPOSITS_CHECKING_PAGE,
    subItems: [],
  },
  {
    title: "Tiered Deposit",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: DEPOSITS_TIERED_PAGE,
    subItems: [],
  },
  {
    title: "Time Deposit",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: DEPOSITS_TIME_DEPOSIT,
    subItems: [],
  },
  {
    title: "Foreign Currency Deposit",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: DEPOSITS_FOREIGN_CURRENCY_DEPOSIT,
    subItems: [],
  },
];

const CARDS_SUBITEMS = [
  {
    title: "Debit Cards",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: CARDS_DEBIT_CARDS,
    subItems: [],
  },
  {
    title: "Prepaid Cards",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: CARDS_PREPAID_CARDS,
    subItems: [],
  },
  {
    title: "Credit Cards",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: CARDS_CREDIT_CARDS,
    subItems: [],
  },
];

const ACQUIRED_ASSETS = [
  {
    title: "Pre-Owned Auto Loans",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ACQUIRED_ASSETS_AUTO_LOANS,
    subItems: [],
  },
  {
    title: "Pre-Owned Properties",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ACQUIRED_ASSETS_PROPERTY,
    subItems: [],
  },
];
const LOANS_SUBITEMS = [
  {
    title: "Loans Overview",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: LOANS_OVERVIEW,
    subItems: [],
  },
  {
    title: "Auto Loan",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: LOANS_AUTO_LOANS,
    subItems: [],
  },
  {
    title: "Home Loan",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: LOANS_HOME_LOANS,
    subItems: [],
  },
  {
    title: "Personal Loan",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: LOANS_PERSONAL_LOANS,
    subItems: [],
  },
];
const INSURANCE_SUBITEMS = [
  {
    title: "EastWest Ageas Insurance",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_EXTERNAL,
    link: AGEAS_INSURANCE,
    subItems: [],
  },
  {
    title: "EastWest Insurance Brokerage",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: BUSINESS_INSURANCE,
    subItems: [],
  },
];

const INVESTMENTS_SUBITEMS = [
  {
    title: "Investments Overview",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: INVESTMENTS_OVERVIEW,
    subItems: [],
  },
  {
    title: "UITF",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: INVESTMNETS_UITF,
    subItems: [],
  },
  {
    title: "Fixed-Income",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: INVESTMENTS_FIXED_INCOME,
    subItems: [],
  },
  {
    title: "Trust",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: INVESTMENTS_TRUST,
    subItems: [],
  },
];

const menus = [
  {
    title: "PERSONAL",
    type: MAIN_ITEM_MAIN_SECTION,
    linkType: LINK_TYPE_INTERNAL,
    link: "/",
    subItems: [
      {
        title: "Online Banking",
        type: MAIN_ITEM_SECTION,
        linkType: null,
        link: "",
        subItems: [
          {
            title: "Personal",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_EXTERNAL,
            link: EASTWEST_ONLINE_PAGE,
            subItems: null,
          },
          {
            title: "Travel Money",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_EXTERNAL,
            link: TRAVEL_MONEY_URL,
          },
          {
            title: "Easyway Online - Personal",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_EXTERNAL,
            link: EASYWAY_PERSONAL_ONLINE,
          },
        ],
      },
      {
        title: "Products & Services",
        type: MAIN_ITEM_PARENT,
        linkType: null,
        link: "",
        subItems: [
          {
            title: "Deposits",
            type: MAIN_ITEM_PARENT,
            linkType: null,
            link: "",
            subItems: DEPOSIT_SUBITEMS,
          },
          {
            title: "Easyway",
            type: MAIN_ITEM_MENU_ITEM,
            // linkType: LINK_TYPE_EXTERNAL,
            // link: OLD_EASYWAY,
            linkType: LINK_TYPE_INTERNAL,
            link: EASYWAY_STAND_ALONE_PATH,
            subItems: [],
          },
          {
            title: "Instapay",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: INSTAPAY_PESONET,
            subItems: [],
          },
          {
            title: "EW Billers",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: OTHER_SERVICES_EWBILLERS,
            subItems: null,
          },
          {
            title: "Cards",
            type: MAIN_ITEM_PARENT,
            linkType: null,
            link: "",
            subItems: CARDS_SUBITEMS,
          },
          {
            title: "Loans",
            type: MAIN_ITEM_PARENT,
            linkType: null,
            link: "",
            subItems: LOANS_SUBITEMS,
          },
          {
            title: "Acquired Assets",
            type: MAIN_ITEM_PARENT,
            linkType: null,
            link: "",
            subItems: ACQUIRED_ASSETS,
          },
          {
            title: "Investments",
            type: MAIN_ITEM_PARENT,
            linkType: null,
            link: "",
            subItems: INVESTMENTS_SUBITEMS,
          },
          {
            title: "Insurance",
            type: MAIN_ITEM_PARENT,
            linkType: null,
            link: "",
            subItems: INSURANCE_SUBITEMS,
          },
          {
            title: "Eastwest Priority",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_EXTERNAL,
            link: PRIORITY_WEBSITE,
            subItems: [],
          },
        ],
      },
    ],
  },
  {
    title: "BUSINESS",
    type: MAIN_ITEM_MAIN_SECTION,
    linkType: LINK_TYPE_INTERNAL,
    link: BUSINESS,
    subItems: [
      {
        title: "Online Banking",
        type: MAIN_ITEM_SECTION,
        linkType: null,
        link: "",
        subItems: [
          {
            title: "Corporate",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_EXTERNAL,
            link: EASTWEST_CORPORATE,
            subItems: null,
          },
          {
            title: "Easybiz Online - Corporate",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_EXTERNAL,
            link: EASYBIZ_CORPORATE_ONLINE,
          },
        ],
      },
      {
        title: "Products & Services",
        type: MAIN_ITEM_PARENT,
        linkType: null,
        link: "",
        subItems: [
          // {
          //   title: "Business",
          //   type: MAIN_ITEM_MENU_ITEM,
          //   linkType: LINK_TYPE_INTERNAL,
          //   link: BUSINESS,
          //   subItems: [],
          // },
          {
            title: "Deposits",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: BUSINESS_DEPOSIT,
            subItems: [],
          },
          {
            title: "Cash Management",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: BUSINESS_CASH_MANAGEMENT_SOLUTION,
            subItems: [],
          },

          {
            title: "Business Loans",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: BUSINESS_LOAN_SOLUTION,
            subItems: [],
          },
          {
            title: "Investments and Trust",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: BUSINESS_INVESTMENT,
            subItems: [],
          },
          {
            title: "Forex Services",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: BUSINESS_FOREX_SERVICE,
            subItems: [],
          },
          {
            title: "Insurance",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: BUSINESS_INSURANCE,
            subItems: [],
          },
          {
            title: "EW Billers",
            type: MAIN_ITEM_MENU_ITEM,
            linkType: LINK_TYPE_INTERNAL,
            link: OTHER_SERVICES_EWBILLERS,
            subItems: null,
          },
        ],
      },
    ],
  },
  {
    title: "About Us",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ABOUT_PATH,
    onlyShownOnMobile: true,
    subItems: [],
  },
  {
    title: "Corporate Information",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ABOUT_WHO_WE_ARE,
    subItems: [],
  },
  {
    title: "Investor Relations",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ABOUT_INVESTOR_RELATIONS,
    subItems: [],
  },
  {
    title: "Newsroom",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ABOUT_NEWS_ROOM,
    subItems: [],
  },
  {
    title: "Advisories",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ADVISORIES,
    subItems: [],
  },
  {
    title: "Careers",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: ABOUT_CAREERS,
    subItems: [],
  },
  {
    title: "Terms of Use",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: TERMS_OF_USE_PATH,
    subItems: [],
  },
  {
    title: "Privacy Statement",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: PRIVACY_STATEMENT,
    subItems: [],
  },
  // {
  //   title: "Privacy Statement",
  //   type: MAIN_ITEM_MENU_ITEM,
  //   linkType: LINK_TYPE_INTERNAL,
  //   link: PRIVACY_STATEMENT,
  //   subItems: [],
  // },
  {
    title: "Store and ATM Locator",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: STORE_DIRECTORY,
    subItems: [],
  },
  {
    title: "Contact Us",
    type: MAIN_ITEM_MENU_ITEM,
    linkType: LINK_TYPE_INTERNAL,
    link: CONTACT_US,
    subItems: [],
  },
];

export default menus;
